import CompositionEstimatesClass from "components/jiffy/products/composition-estimates-class";
import { updateTimeleftDisplay, formatDeliveryDateText } from "common/utils/delivery/dtf-delivery";
import { shouldShowTimeRange } from "common/utils/format/date";

const fetcher = new CompositionEstimatesClass();

// Getters
const $getDeliveryContainersByCompositionId = compositionId =>
  document.querySelectorAll(
    `.product-card-dtf-v2 .js-dtf-landing-delivery[data-composition-id="${compositionId}"]`
  );

const $getAllDeliverySections = () =>
  document.querySelectorAll(".product-card-dtf-v2 .js-dtf-landing-delivery[data-composition-id]");

const $getSpinner = $container => $container.querySelector(".js-plp-delivery-spinner");

const $getDeliveryContainer = $container => $container.querySelector(".js-plp-dates-container");

const $getDeliveryDate = $container => $container.querySelector(".js-plp-delivery-date");

const $getTimeleft = $container => $container.querySelector(".js-plp-delivery-timeleft");

const $getTimeleftText = $container => $container.querySelector(".js-plp-delivery-timeleft-text");

const getCompositionIds = () => {
  const $deliverySections = $getAllDeliverySections();
  return Array.from($deliverySections)
    .map($section => $section.dataset.compositionId)
    .filter(Boolean);
};

const getDateFlags = date => ({
  isToday: date.toLowerCase().includes("today"),
  isTomorrow: date.toLowerCase().includes("tomorrow")
});

// Setters
const setSpinnerHidden = $spinner => {
  if ($spinner) {
    $spinner.classList.add("hidden");
  }
};

const setDeliveryDateText = ($deliveryDate, { date, deliveryTime, deliveryTimeEnd }) => {
  if (!$deliveryDate) return;
  $deliveryDate.textContent = formatDeliveryDateText(date, {
    deliveryTime,
    deliveryTimeEnd,
    includeByForTimeRange: true
  });
};

const setDeliveryContainerVisible = $deliveryContainer => {
  $deliveryContainer.classList.remove("hidden");
};

const setTimeleftDisplay = ($timeleft, isToday, timeleft) => {
  updateTimeleftDisplay($timeleft, isToday, timeleft);
};

const setTimeleftText = ($timeleftText, { date, deliveryTime, deliveryTimeEnd }) => {
  if (!$timeleftText) return;

  const isTimeRangeAvailable = shouldShowTimeRange(date) && deliveryTime && deliveryTimeEnd;

  $timeleftText.classList.toggle("hidden", isTimeRangeAvailable);
};

// Actions
const renderSingleDeliveryContainer = ($container, estimate) => {
  const $spinner = $getSpinner($container);
  const $deliveryContainer = $getDeliveryContainer($container);
  const $deliveryDate = $getDeliveryDate($container);
  const $timeleft = $getTimeleft($container);
  const $timeleftText = $getTimeleftText($container);

  setSpinnerHidden($spinner);

  if (!$deliveryContainer || !$deliveryDate || !estimate?.date) return;

  const {
    date,
    delivery_time: deliveryTime,
    delivery_time_end: deliveryTimeEnd,
    timeleft
  } = estimate;

  const { isToday } = getDateFlags(date);

  setDeliveryDateText($deliveryDate, { date, deliveryTime, deliveryTimeEnd });
  setTimeleftDisplay($timeleft, isToday, timeleft);
  setTimeleftText($timeleftText, { date, deliveryTime, deliveryTimeEnd });
  setDeliveryContainerVisible($deliveryContainer);
};

const renderDeliveryEstimatesForComposition = (compositionId, estimate) => {
  const $containers = $getDeliveryContainersByCompositionId(compositionId);
  $containers.forEach($container => renderSingleDeliveryContainer($container, estimate));
};

const handleDeliveryEstimatesSuccess = (data, compositionIds) => {
  if (!data.success || !data.estimates) return;

  compositionIds.forEach(compositionId => {
    const estimate = data.estimates[compositionId];
    if (estimate?.date) {
      renderDeliveryEstimatesForComposition(compositionId, estimate);
    }
  });
};

const handleDeliveryEstimatesError = (error, compositionIds) => {
  window.Honeybadger?.notify("Error loading delivery estimates for DTF product card v2", {
    context: {
      compositionIds,
      errorMessage: error?.message
    }
  });
};

const fetchDeliveryEstimates = compositionIds => {
  fetcher
    .fetch(compositionIds)
    .then(([data]) => handleDeliveryEstimatesSuccess(data, compositionIds))
    .catch(error => handleDeliveryEstimatesError(error, compositionIds));
};

// Inits
const initDeliveryEstimates = () => {
  const compositionIds = getCompositionIds();

  if (compositionIds.length > 0) {
    fetchDeliveryEstimates(compositionIds);
  }
};

export default () => {
  initDeliveryEstimates();
};
